import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const replayWeb: PluginWebManifest = {
  // replay uses raw `routes` + `navItems` + `agentActions` +
  // `commands` (instead of `definePage`) because it ships several
  // routes — live replays, saved replays, chromeless share view,
  // editor — that don't fit a single page declaration. The overview
  // card is written by hand and points to the saved-replays list,
  // which is the canonical landing surface for the feature.
  overviewCards: [
    {
      to: '/replays',
      label: 'Replays',
      icon: 'Play',
      description: 'Replay agent runs with simulated real-time playback.',
      details:
        'Captures agent runs and plays them back step by step so you can review what an agent did, demo an automation, or share a session externally. Saved replays can be opened in a chromeless full-viewport view via a public share link — no Reflex session required.',
      features: [
        '"Replay" agent action — open the live replay for an agent',
        '"Save as replay" agent action with a sharable saved copy',
        'Replays list at /replays with editor and live views',
        'Public chromeless share links (frame, autoplay, loop, controls via query params)',
        'Saved replays survive after the agent devbox is gone',
      ],
      group: 'plugins',
    },
  ],
  routes: [
    {
      path: '/replay/:agentId',
      componentPath: '@reflex/plugin-replay/web/ReplayPage',
    },
    {
      // The unified Replays page: one chrome whose tab strip swaps content
      // in place. This plugin owns the page and its Agents tab; other
      // plugins add their own kind of replay through a `pageTabs`
      // contribution for the `replays` slot (`plugin-flows` adds
      // Automations), so there is no sibling route to navigate to.
      path: '/replays',
      componentPath: '@reflex/plugin-replay/web/ReplaysPage',
    },
    {
      path: '/replays/:id/live',
      componentPath: '@reflex/plugin-replay/web/LiveReplayPage',
      chromeless: true,
      public: true,
    },
    {
      path: '/replays/:id',
      componentPath: '@reflex/plugin-replay/web/ReplayEditorPage',
    },
  ],
  navItems: [
    {
      to: '/replays',
      label: 'Replays',
      icon: 'Play',
      group: 'plugins',
    },
  ],
  agentActions: [
    {
      label: 'Replay',
      icon: 'Play',
      to: '/replay/{agentId}',
      category: 'execution',
    },
    {
      label: 'Save as replay',
      icon: 'Save',
      componentPath: '@reflex/plugin-replay/web/SaveAsReplayDialog',
      category: 'persistence',
    },
  ],
  commands: [
    {
      label: 'Replay',
      to: '/replay',
      icon: 'Play',
      group: 'misc',
    },
    {
      label: 'Replays',
      to: '/replays',
      icon: 'Play',
      group: 'misc',
    },
  ],
};
